<template>
    <div class="loginBox">
        <h1> {{ $t('loginTitle') }} </h1>
        <div v-loading="loading">
            <Login :before="param"/>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Login from '@/components/Login'
    import api from '@/api/api'

    export default {
        components: {
            Login
        },
        props: {
            param: {}
        },
        computed: {
            ...mapGetters({
                authToken: 'getAuthToken',
                user: 'getCurrentUser'
            }),
        },
        data () {
            return {
                loading: false
            }
        },
        created () {
            this.loading = true
            if (this.authToken) {
                if (this.user) {                    
                    if (this.user.roles[0].name === 'provider') { 
                        this.user.provider ? this.$router.push('/dashboard/provider/' + this.user.provider.id) : this.$router.push('/dashboard/profile') 
                    } else {
                        this.$router.push({name: 'Home'})
                    }
                } else {
                    this.$router.push({name: 'Home'})
                }
                this.loading = false                
            } else {
                this.loading = false
            }
        }
    }
</script>

<style scoped>
    h1 {
        text-align: center;
    }
    .loginBox {
        margin-left: 28%;
        margin-right: 28%;
        margin-top: 36px;
    }

    @media (min-width: 1200px) {
        .loginBox {
            margin-left: 36%;
            margin-right: 36%;
        }
    }

    @media (max-width: 576px) {
        .loginBox {
            margin-left: 12px;
            margin-right: 12px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Index.vue